export const MAPPING = {
  "47 Claremont": {
    "suite-3": "3-Person Suite",
    "suite-4": "4-Person Suite",
    "suite-5": "5-Person Suite",
    "suite-6": "6-Person Suite",
    "suite-7": "7-Person Suite"
  },
  "600 West 113": {
    double: "Double",
    single: "Single",
    "double-walkthrough": "Walk-Through Double"
  },
  Broadway: {
    single: "Single",
    double: "Small Double (39/40 lines)"
  },
  "Carlton Arms": {
    "suite-3": "3-Person Suite",
    "suite-4": "4-Person Suite",
    "suite-5": "5-Person Suite",
    "suite-6": "6-Person Suite",
    "suite-8": "7-Person Suite"
  },
  "East Campus": {
    "suite-2": "2-Person Highrise Flat",
    "suite-6-highrise-6s": "6 Person Highrise Suite (All Sgl)",
    "suite-5-highrise-3s-1d": "5 Person Highrise Suite (3 Sgl/1 Dbl)",
    "suite-5-highrise-5s": "5 Person Highrise Suite (All Sgl)",
    "suite-4-townhouse": "4 Person Townhouse Suite (All Sgl)",
    "suite-6-townhouse-6s": "6-Person Townhouse Suite (all singles)",
    "suite-6-townhouse-4s-1d": "6-Person Townhouse Suite (4 Sgl / 1 Dbl)",
    "ra-4s-in-6s": "6 Person Highrise Suite (All Sgl)",
    "ra-2s-in-4s": "4 Person Townhouse Suite (All Sgl)",
    "double": "6th Floor Highrise Double"
  },
  Furnald: {
    double: "Double",
    single: "Single"
  },
  Harmony: {
    double: "Double",
    single: "Single",
    "suite-6": "6 Person Suite (4 Sgl/1 Dbl)"
  },
  Hogan: {
    "suite-4": "4-Person Suite",
    "suite-5": "5-Person Suite",
    "ra-2s-in-4s": "2 in 4 Person Suite w/RA",
    "ra-4s-in-6s": "4 in 6 Person Suite w/RA"
  },
  McBain: {
    double: "Double",
    single: "Single"
  },
  River: {
    single: "Single"
  },
  Ruggles: {
    "suite-4": "4-Person Suite",
    "suite-6": "6-Person Suite",
    "suite-8-2s-3d": "8-Person Suite",
    "suite-8-4s-2d": "8-Person Suite",
    "ra-2s-in-4s": "2 in 4-person Suite w/RA"
  },
  Schapiro: {
    double: "Double",
    single: "Single",
    "double-walkthrough": "Walk-Through Doubles (05/07 lines)"
  },
  Watt: {
    "double-studio": "Studio Double",
    "single-studio": "Studio Single",
    "apartment-1br": "1-Bedroom Apartment",
    "apartment-2br": "2-Bedroom Apartment"
  },
  Woodbridge: {
    "apartment-1br": "Apartment"
  },
  Wien:{
    "double": "Double",
    "double-walkthrough": "Double",
    "single": "Single"
  }
};
